var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"completion"},[_vm._m(0),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"target",staticStyle:{"width":"100%","height":"400px"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h3',[_vm._v("需求完成情况")]),_c('span',[_vm._v("(期望交付 / 制作完成时间)")])])
}]

export { render, staticRenderFns }